import React from 'react';
import {
  PropTypes
} from 'prop-types';
import { connect } from "react-redux";
import client, {
  socket
} from './../services/FeathersService';

class FeathersProvider extends React.Component {
  constructor (props) {
    super(props);

    socket.io.engine.on('upgrade', function (transport) {
      // socket upgrade
    });

    this.state = {
      feathers: client,
      socket
    };
  }

  static propTypes = {
    host: PropTypes.string
  };

  static childContextTypes = {
    socket: PropTypes.oneOfType([
      PropTypes.bool, PropTypes.object
    ]),
    feathers: PropTypes.oneOfType([
      PropTypes.bool, PropTypes.object
    ])
  };

  getChildContext () {
    return {
      feathers: this.state.feathers,
      socket: this.state.socket
    };
  }

  render () {
    return this.props.children;
  }
}

const mapStateToProps = (state) => {
  return {

  };
};

const mapDispatchToProps = (dispatch) => {
  return {

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FeathersProvider);



// WEBPACK FOOTER //
// ./client/providers/FeathersProvider.js